import React from 'react';
import { Form } from 'rsuite';

export const Field = React.forwardRef((props, ref) => {
    const { name, label, disabled = "false", accepter, ...rest } = props;
    return (
        <Form.Group controlId={name} ref={ref} >
            <Form.ControlLabel>{label} </Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} disabled={disabled === "true"} {...rest} />
        </Form.Group>
    );
});